// extracted by mini-css-extract-plugin
export default {"card":"dashboard_card__EQV-7","icon":"dashboard_icon__zt7k3","cardTitle":"dashboard_cardTitle__sxEYn"};